/**
 * Portable Appliance Testing (PAT) - PDF Transform
 * Evaluates the register via patEvaluator and builds a verification QR payload.
 */
import { evaluateRegister } from '../../utils/electrical/patEvaluator.js';

export const MAX_ROWS_PER_PAGE = 30;

/**
 * Build the register verification QR payload.
 */
export const buildVerificationPayload = (formData) => {
  const summary = evaluateRegister(formData.appliances || []).summary;
  return {
    type: 'PAT',
    certNo: formData.jobDetails?.certificateNumber || '',
    date: formData.jobDetails?.testDate || '',
    dutyHolder: formData.jobDetails?.dutyHolder || '',
    location: formData.jobDetails?.testLocation || '',
    engineer: formData.jobDetails?.engineerName || '',
    card: formData.jobDetails?.engineerCardNumber || '',
    tested: summary.totalCount,
    passed: summary.passCount,
    failed: summary.failCount
  };
};

export const transformForPDF = (formData) => {
  const evaluation = evaluateRegister(formData.appliances || []);
  const registerPasses = evaluation.registerPasses;

  return {
    title: 'PORTABLE APPLIANCE TESTING CERTIFICATE & REGISTER',
    subtitle: 'In-Service Inspection and Testing of Electrical Equipment',
    standard: 'IET Code of Practice for In-Service Inspection and Testing of Electrical Equipment',
    template: 'pat',
    verification: buildVerificationPayload(formData),
    jobDetails: {
      certificateNumber: formData.jobDetails?.certificateNumber || '',
      testDate: formData.jobDetails?.testDate || '',
      dutyHolder: formData.jobDetails?.dutyHolder || '',
      testLocation: formData.jobDetails?.testLocation || '',
      companyName: formData.jobDetails?.companyName || '',
      engineerName: formData.jobDetails?.engineerName || '',
      engineerCardNumber: formData.jobDetails?.engineerCardNumber || ''
    },
    testEquipment: (formData.testEquipment || []).map(eq => ({
      make: eq.equipmentMake || '',
      model: eq.equipmentModel || '',
      serial: eq.equipmentSerial || '',
      calibrationDate: eq.calibrationDate || '',
      calibrationDue: eq.calibrationDue || ''
    })),
    appliances: evaluation.results.map(a => ({
      itemId: a.itemId || '',
      description: a.description || '',
      applianceClass: a.applianceClass || '',
      visualInspection: a.visualInspection || '',
      earthContinuity: a.earthContinuity ?? '',
      leadResistance: a.leadResistance ?? '',
      insulationResistance: a.insulationResistance ?? '',
      touchLeakage: a.touchLeakage ?? '',
      testResult: a.evaluation?.status || a.testResult || '',
      autoResult: a.evaluation?.status || '',
      retestPeriod: a.retestPeriod || '',
      notes: a.notes || ''
    })),
    summary: evaluation.summary,
    registerPasses,
    statement: registerPasses
      ? 'All items passed inspection and testing. The equipment is safe for continued use.'
      : 'One or more items failed inspection and testing. Failed items must not be used until repaired and re-tested.',
    declaration: {
      engineerSignature: formData.declaration?.engineerSignature || '',
      customerSignature: formData.declaration?.customerSignature || ''
    }
  };
};

export default transformForPDF;